export default __webpack_public_path__ + "static/media/EL-20-3050-32.63183f9e.png";